import { render, staticRenderFns } from "./AdicionarPacienteEsperaCard.vue?vue&type=template&id=537e8d95&scoped=true"
import script from "./AdicionarPacienteEsperaCard.vue?vue&type=script&lang=js"
export * from "./AdicionarPacienteEsperaCard.vue?vue&type=script&lang=js"
import style0 from "./AdicionarPacienteEsperaCard.vue?vue&type=style&index=0&id=537e8d95&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537e8d95",
  null
  
)

export default component.exports